// Rouvy Analyzer (rouvyanalyzer.com) — независимый сторонний сервис, который по
// маршруту прикидывает время прохождения, раскладку по темпу и выгодный выбор
// велосипеда. С ROUVY он не связан и нам не принадлежит.
//
// Маршрут у них адресуется тем же числовым id маршрута ROUVY, который лежит в
// routes.rouvy_id (у нас он приходит из ссылки вида riders.rouvy.com/route/<id>).
// Прогноз показываем у себя (RouvyAnalyzerModal, данные через бэкенд —
// RouvyAnalyzerService), а ссылка ведет на полную страницу маршрута у них.
export const ROUVY_ANALYZER_URL = 'https://www.rouvyanalyzer.com';

export const rouvyAnalyzerRouteUrl = (rouvyId) => (
  rouvyId ? `${ROUVY_ANALYZER_URL}/RouteAnalyzer?id=${encodeURIComponent(rouvyId)}` : null
);
